<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll">
      <div class="sidebar-user-profile">
        
        <span class="user-img me-2 flex-shrink-0">
            <img v-if="store?.state?.auth?.user?.profile_picture" :src="store?.state?.auth?.user?.profile_picture"  alt="User Image" />
            <img v-else src="@/assets/img/profiles/avatar-21.jpg" alt="User Image" />
            <span class="status online"></span>
        </span>
        <div class="user-detail">
          <p class="user-designation">{{ store?.state?.auth?.user?.designation || "Undesignated" }}</p>
          <p class="user-name">{{ store?.state?.auth?.user?.name }}</p>
        </div>
      </div>
      <perfect-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
        <div id="sidebar-menu" class="sidebar-menu">
          <horizontal-header></horizontal-header>
          <ul class="sidebar-vertical">
            <li v-for="item in routesRoleWise" :key="`item-${item.id}`"  :class="item.titleOnly ? 'menu-title' : 'submenu'">
              <span v-if="item.titleOnly">{{ item.title }}</span>
              <template v-else>
                <a 
                :href="`#${item.id}`" 
                data-bs-toggle="collapse" 
                role="button" 
                aria-expanded="false"
                :aria-controls="item.id"
                :class="{ active: item.subMenus.some(el => {
                  if(el.hasSubmenus) {
                    
                    return el.path === $route.path || el.subMenus.some(e => e.path === $route.path)
                  }

                 return el.path === $route.path
                }), subdrop: item.subMenus.some(el => {
                  if(el.hasSubmenus) {
                    
                    return el.path === $route.path || el.subMenus.some(e => e.path === $route.path)
                  }

                 return el.path === $route.path
                })}"
                >
                 
                <i v-html="item.icon"></i> <span>{{ item.title }}</span>
                  <span class="menu-arrow"></span></a>
                <ul class="collapse" :id="item.id"
                  :class="{ show:item.subMenus.some(el => {
                  if(el.hasSubmenus) {
                    
                    return el.path === $route.path || el.subMenus.some(e => e.path === $route.path)
                  }

                 return el.path === $route.path
                }) }">
                  <li v-for="submenu in item.subMenus" :key="`submenu-${submenu.path}`">
                    <!-- warning alert routes -->
                    <a v-if="submenu.title == 'Chat' || submenu.title == 'Call' || submenu.title == 'Email'" data-bs-toggle="modal"
                    data-bs-target="#warning-alert-modal" >{{ submenu.title }}</a>
                    <!-- without nested submenus -->
                    <router-link v-else-if="!submenu.hasSubmenus"  v-bind:class="{ active: currentPath == submenu.path }" :to="submenu.path">{{submenu.title }}</router-link>
                    <!-- with nested submenus -->
                    <li v-if="submenu.hasSubmenus"  class="submenu">
                  <a
                :href="`#${submenu.id}`" 
                data-bs-toggle="collapse" 
                role="button" 
                aria-expanded="false"
                :aria-controls="submenu.id"
                :class="{ active: submenu.subMenus?.some(el => el.path === $route.path), 
                  subdrop: submenu.subMenus?.some(el => el.path === $route.path) }"
                  >
                    <span> {{ submenu.title }}</span> <span class="menu-arrow"></span>
                  </a>
                  <ul class="collapse" :id="submenu.id"
                  :class="{ show: submenu.subMenus.some(el => el.path === $route.path) }">
                    <li v-for="nestedSubmenu in submenu.subMenus" :key="`nestedSubmenu-${nestedSubmenu.path}`">
                      <router-link
                        v-bind:class="{ active: currentPath == nestedSubmenu.path }"
                        :to="nestedSubmenu.path"
                        >{{ nestedSubmenu.title }}</router-link
                      >
                    </li>
                   
                  </ul>
                </li>
                  </li>
                 
                </ul>
              </template>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
      <perfect-scrollbar class="scroll-area help-and-support" :settings="settings" @ps-scroll-y="scrollHanle">
        <div id="sidebar-menu" class="sidebar-menu">
          <horizontal-header></horizontal-header>
          <ul class="sidebar-vertical">
            <li v-for="item in filteredHelpAndSupportData" :key="`item-${item.id}`"  :class="item.titleOnly ? 'menu-title' : 'submenu'">
              <span v-if="item.titleOnly">{{ item.title }}</span>
              <template v-else>
                <a 
                :href="`#${item.id}`" 
                data-bs-toggle="collapse" 
                role="button" 
                aria-expanded="false"
                :aria-controls="item.id"
                :class="{ active: item.subMenus.some(el => {
                  if(el.hasSubmenus) {
                    
                    return el.path === $route.path || el.subMenus.some(e => e.path === $route.path)
                  }

                 return el.path === $route.path
                }), subdrop: item.subMenus.some(el => {
                  if(el.hasSubmenus) {
                    
                    return el.path === $route.path || el.subMenus.some(e => e.path === $route.path)
                  }

                 return el.path === $route.path
                })}"
                >
                 
                <i v-html="item.icon"></i> <span>{{ item.title }}</span>
                  <span class="menu-arrow"></span></a>
                <ul class="collapse" :id="item.id"
                  :class="{ show:item.subMenus.some(el => {
                  if(el.hasSubmenus) {
                    
                    return el.path === $route.path || el.subMenus.some(e => e.path === $route.path)
                  }

                 return el.path === $route.path
                }) }">
                  <li v-for="submenu in item.subMenus" :key="`submenu-${submenu.path}`">
                    <!-- warning alert routes -->
                    <a v-if="submenu.title == 'Chat' || submenu.title == 'Call' || submenu.title == 'Email'" data-bs-toggle="modal"
                    data-bs-target="#warning-alert-modal" >{{ submenu.title }}</a>
                    <!-- without nested submenus -->
                    <router-link v-else-if="!submenu.hasSubmenus"  v-bind:class="{ active: currentPath == submenu.path }" :to="submenu.path">{{submenu.title }}</router-link>
                    <!-- with nested submenus -->
                    <li v-if="submenu.hasSubmenus"  class="submenu">
                  <a
                :href="`#${submenu.id}`" 
                data-bs-toggle="collapse" 
                role="button" 
                aria-expanded="false"
                :aria-controls="submenu.id"
                :class="{ active: submenu.subMenus?.some(el => el.path === $route.path), 
                  subdrop: submenu.subMenus?.some(el => el.path === $route.path) }"
                  >
                    <span> {{ submenu.title }}</span> <span class="menu-arrow"></span>
                  </a>
                  <ul class="collapse" :id="submenu.id"
                  :class="{ show: submenu.subMenus.some(el => el.path === $route.path) }">
                    <li v-for="nestedSubmenu in submenu.subMenus" :key="`nestedSubmenu-${nestedSubmenu.path}`">
                      <router-link
                        v-bind:class="{ active: currentPath == nestedSubmenu.path }"
                        :to="nestedSubmenu.path"
                        >{{ nestedSubmenu.title }}</router-link
                      >
                    </li>
                   
                  </ul>
                </li>
                  </li>
                 
                </ul>
              </template>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
      <div class="siderbar-footer">
        <div class="powered-by">
          Powered By: <img src="@/assets/img/hcmlogo.png" alt="Culture HCM" />
        </div>
      </div>
    </div>
  </div>
  <!-- /Sidebar -->

  <two-col-sidebar></two-col-sidebar>
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { mapGetters, mapState, mapActions } from "vuex"
import { sidebarRoutes, allPermissionsWithRoutes, allPermissionsWithRoute } from "@/staticData"
import RolePermissionService from "@/services/RolePermissionService";
import GeoFencingService from "@/services/GeoFencingService";
import store from "../../store/index";

const helpAndSupportData = [
  {
    id: 'sidebarHelpSupport',
    title: "Help & Support",
    icon: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0Z" fill="black" fill-opacity="0.55"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.06098 5.66036C8.70277 5.64668 8.35379 5.77586 8.09081 6.01948C7.82784 6.2631 7.67242 6.60121 7.65873 6.95942C7.63976 7.45612 7.22173 7.84339 6.72503 7.82441C6.22834 7.80544 5.84107 7.38741 5.86004 6.89071C5.89195 6.05546 6.25436 5.26708 6.86753 4.69903C7.48071 4.13097 8.29443 3.82977 9.12969 3.86167C9.96495 3.89358 10.7533 4.25599 11.3214 4.86916C11.887 5.4797 12.188 6.28905 12.1591 7.12052C12.1519 7.52919 12.0639 7.93242 11.9 8.30692C11.7346 8.68475 11.4954 9.02573 11.1965 9.30982C10.8975 9.59391 10.5447 9.81537 10.159 9.96121C10.0684 9.99546 9.97636 10.0254 9.88329 10.0509V10.5359C9.88329 11.0329 9.48034 11.4359 8.98329 11.4359C8.48623 11.4359 8.08329 11.0329 8.08329 10.5359V9.25967C8.08329 9.0152 8.18274 8.78125 8.35878 8.61161C8.53481 8.44197 8.77228 8.35124 9.01659 8.36028C9.18904 8.36667 9.36104 8.33852 9.52246 8.2775C9.68389 8.21648 9.83149 8.12381 9.95659 8.00493C10.0817 7.88606 10.1818 7.74339 10.251 7.58529C10.3202 7.42719 10.357 7.25686 10.3595 7.0843L10.36 7.06261C10.3737 6.7044 10.2446 6.35542 10.0009 6.09244C9.75731 5.82947 9.4192 5.67405 9.06098 5.66036ZM8.07428 13.2429C8.07428 12.7458 8.47722 12.3429 8.97428 12.3429H8.98328C9.48033 12.3429 9.88328 12.7458 9.88328 13.2429C9.88328 13.74 9.48033 14.1429 8.98328 14.1429H8.97428C8.47722 14.1429 8.07428 13.74 8.07428 13.2429Z" fill="white"/>
</svg>
`,
    subMenus: [
      {
        title: "User Guide",
        path: "/error-403"
      },
      {
        title: "FAQ's",
        path: "/error-403"
      },
      {
        title: "Contact Support",
        path: "/error-403"
      },
      {
        title: "Bug Reports",
        path: "/help-support/app-issue-reporting",
        permission: "app_issue_reporting-list"
      }
    ]
  }
]

export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      sidebarRoutes: sidebarRoutes,
      allPermissionsWithRoutes: allPermissionsWithRoutes,
      allPermissionsWithRoute: allPermissionsWithRoute,
       settings: {
        suppressScrollX: true,
      },
      activeClass: "active",
      allModelPermissions: {},
      permittedRoutes: ["/employee-dashboard"],
      store: store,
      globalGeofenceStatus: 1,
      helpAndSupportData,
    };
  },
  methods: {
    ...mapActions('auth', ['permissionsLoading']),
    async fetchModelWisePermissions(title) {
      return;
      if(title == 'Applications') {
        return;
      }
      
      let permissionsObj = JSON.parse(localStorage.getItem('model-wise-permissions'));
      if (permissionsObj && Object.keys(permissionsObj).includes(title)) {
        
        return;
      } else {
        this.permissionsLoading(true);
        try {
          const payload = {
            model_name: title
          }
          const response = await RolePermissionService.fetchModelWisePermissions(payload);
          if(response.success == true) {
            const resPermissions = response.data;
            const modPers = resPermissions.map((el) => el['permissions'])
            
            this.allModelPermissions[`${title}`] = modPers;
            localStorage.setItem('model-wise-permissions', JSON.stringify(this.allModelPermissions));
            this.permissionsLoading(false);
          } 
        } catch (error) {
          this.permissionsLoading(false);
          console.log('error fetching permissions', error);
        }
      }
    },
    async fetchAllModelsPermission() {
      try {
        const models = store?.state?.auth?.user?.model_name;
        if (!models || !Array.isArray(models)) return;

        let permissionsObj = JSON.parse(localStorage.getItem('model-wise-permissions')) || {};

        // Filter out models that already have permissions cached
        const modelsToFetch = models.filter((model) => !permissionsObj[model]);

        if (modelsToFetch.length === 0) return;

        // Create an array of API call promises
        const permissionRequests = modelsToFetch.map((model) =>
          RolePermissionService.fetchModelWisePermissions({ model_name: model })
            .then((response) => ({ model, response }))
            .catch((error) => ({ model, error }))
        );

        // Wait for all API calls to complete
        const results = await Promise.all(permissionRequests);

        // Process the results
        results.forEach(({ model, response, error }) => {
          if (error) {
            console.error(`Error fetching permissions for model: ${model}`, error);
            return;
          }

          if (response.success) {
            const resPermissions = response.data;
            const modPers = resPermissions.map((el) => el['permissions']);
            this.allModelPermissions[model] = modPers;

            // Update localStorage
            localStorage.setItem('model-wise-permissions', JSON.stringify(this.allModelPermissions));
          }
        });

      } catch (error) {
        console.log('Error fetching all model permissions:', error);
      }
    },
    scrollHanle(evt) { },
    redirectReload() {
      this.$router.push({ path: "/horizontal-timeline" }).then(() => {
        this.$router.go();
      });
    },
    createMyPermissions(userPermissions) {
      const allPermissionKeys = Object.keys(this.allPermissionsWithRoutes);
      const modifiedPermissions = {};
      
      if(userPermissions && userPermissions.length > 0) {
        allPermissionKeys.forEach((key) => {
          if (userPermissions.includes(key)) {
            modifiedPermissions[key] = this.allPermissionsWithRoutes[key];
          }
        });
      }
      
      return modifiedPermissions;
    },
    createMyModels(userModels) {
      const allModelKeys = Object.keys(this.allPermissionsWithRoute);
      const modifiedModels = {};
      
      allModelKeys.forEach((key) => {
        if (userModels.includes(key)) {
          modifiedModels[key] = this.allPermissionsWithRoute[key];
        }
      });
      
      return modifiedModels;
    },
    isPathPermitted (path, routes){
      if (!path) return false; // Ensure the path is valid
      return routes.some((route) => {
        if (Array.isArray(route)) {
          return this.isPathPermitted(path, route); // Recursively handle nested arrays
        }
        return route === path; // Match the path
      });
    },
    async fetchGlobalGeofenceStatus() {
      try {
        const status = await GeoFencingService.getGlobalGeofenceStatus();
        this.globalGeofenceStatus = status ?? 0;
      } catch (error) {
        this.globalGeofenceStatus = 0;
      }
    },
    handleGlobalGeofenceStatusUpdated(event) {
      const status = Number(event?.detail?.status ?? 0);
      this.globalGeofenceStatus = status === 1 ? 1 : 0;
    },
    // createMyPermissions(userPermissions) {
    //   const allPermissionKeys = Object.keys(this.allPermissionsWithRoutes);
    //   const modifiedPermissions = {};
    //   allPermissionKeys.forEach((key) => {
    //     if (userPermissions.includes(key)) {
    //       // Ensure the value is an array before spreading
    //       const routes = Array.isArray(this.allPermissionsWithRoutes[key])
    //         ? this.allPermissionsWithRoutes[key]
    //         : [this.allPermissionsWithRoutes[key]]; // Convert to an array if it's a string
    //       // Initialize the key in modifiedPermissions if it doesn't already exist
    //       if (!modifiedPermissions[key]) {
    //         modifiedPermissions[key] = [];
    //       }

    //       // Append all routes for the key
    //       modifiedPermissions[key].push(...routes);
    //     }
    //   });
    //   return modifiedPermissions;
    // },


  },
  computed: {
    routesRoleWise() {
      // return this.sidebarRoutes;
      // if (!this.userRole) {
      //   return this.sidebarRoutes

      // }
      // const myModels = this.createMyModels(this.$store._state?.data?.auth?.user?.model_name);
      // // this.permittedRoutes = Object.values(myModels).flat(Infinity);

      // // Main function to filter routes
      // const filterRoutes = this.sidebarRoutes.reduce((acc, curr) => {
      //   const newCurr = { ...curr };

      //   const filterSubMenus = (subMenus) => {
      //     return subMenus
      //       .map(subMenu => {
      //         const newSubMenu = { ...subMenu };

      //         if (newSubMenu.subMenus?.length) {
      //           newSubMenu.subMenus = filterSubMenus(newSubMenu.subMenus);
      //         }

      //         // Check if the path exists in any of the permissions
      //         const isPermitted = this.permittedRoutes.some(routes =>
      //           routes.includes(newSubMenu.path)
      //         );

      //         return (newSubMenu.subMenus?.length || isPermitted) ? newSubMenu : null;
      //       })
      //       .filter(Boolean);
      //   };

      //   if (newCurr.subMenus?.length) {
      //     newCurr.subMenus = filterSubMenus(newCurr.subMenus);

      //     if (!newCurr.subMenus.length) {
      //       const myModelNames = this.$store._state?.data?.auth?.user?.model_name;
      //       // return acc,
      //         if(myModelNames.includes(newCurr.title)) {
      //             return [...acc, {
      //               ...newCurr,
      //               subMenus: []
      //             }]
      //         }else {
      //           return acc
      //         }
      //     }
      //   }

      //   return [...acc, newCurr];
      // }, []);

      const myPermissions = this.createMyPermissions(store?.state?.auth?.user?.permission?.map(el => el.name));
      const permittedRoutes = Object.values(myPermissions).flat(Infinity);


      const filterRoutes = this.sidebarRoutes.reduce((acc, curr) => {
        const newCurr = { ...curr };

        if (newCurr.title === "Remote" && this.globalGeofenceStatus !== 1) {
          return acc;
        }

        const filterSubMenus = (subMenus) => {
          return subMenus
            .map(subMenu => {
              const newSubMenu = { ...subMenu };

              if (newSubMenu.subMenus?.length) {
                newSubMenu.subMenus = filterSubMenus(newSubMenu.subMenus);
              }

              if (
                newSubMenu.title === "Geo Fencing" &&
                this.globalGeofenceStatus !== 1
              ) {
                return null;
              }

              // Check if the path exists in any of the permissions
              const isPermitted = permittedRoutes.some(routes =>
                routes.includes(newSubMenu.path)
              );

              return (newSubMenu.subMenus?.length || isPermitted) ? newSubMenu : null;
            })
            .filter(Boolean);
        };

        if (newCurr.subMenus?.length) {
          newCurr.subMenus = filterSubMenus(newCurr.subMenus);

          if (!newCurr.subMenus.length) {
            return acc;
          }
        }
        // if(store.state?.auth?.user?.hcm_id !== 'APD-0001' && store.state?.auth?.user?.hcm_id !== 'APD-0002' && store.state?.auth?.user?.hcm_id !== 'APD-0111') {
        //   if(newCurr.title == 'Payroll') {
        //     let i = newCurr?.subMenus?.findIndex((el) => el.path == "/payroll-management/increment-approval-list");
        //     newCurr?.subMenus?.splice(i, 1)
        //   }
        // }

        return [...acc, newCurr];
      }, []);

      console.log('filtered', filterRoutes)
      return filterRoutes
    },
    currentPath() {
      // console.log(sidebarRoutes, this.$route, this.$store, this.userRole)
      return this.$route.name;
    },
    filteredHelpAndSupportData() {
      const userPermissions = store?.state?.auth?.user?.permission?.map(el => el.name) || [];
      return this.helpAndSupportData.map(item => {
        if (!item.subMenus?.length) return item;
        return {
          ...item,
          subMenus: item.subMenus.filter(sub => !sub.permission || userPermissions.includes(sub.permission))
        };
      });
    },

    ...mapGetters('auth', ["userRole"]),
    ...mapState("auth", ["modelPermissionLoading"]),
  },
  watch: {
    allModelPermissions: {
      
      handler(newValues, oldValues) {

        if(newValues) {
          let allMyListPermissions = [];
            Object.values(newValues).forEach(el => {
              const filteredList = el.filter(e =>  true || e.includes("-list"))
            

            allMyListPermissions =  allMyListPermissions.concat(filteredList);
        })


          

         let  allMyListUrls = ["/employee/bulk-upload"];
        allMyListPermissions.forEach(el => {
         
          if(allPermissionsWithRoutes[el]) {
            allMyListUrls = allMyListUrls.concat(allPermissionsWithRoutes[el])
          }
        });

        this.permittedRoutes = allMyListUrls
        }


      },
      deep: true
    }
  },
  created() {
    this.fetchGlobalGeofenceStatus();
    window.addEventListener(
      "global-geofence-status-updated",
      this.handleGlobalGeofenceStatusUpdated
    );
    // this.fetchAllModelsPermission();
    // const modelWisePermissions = localStorage.getItem('model-wise-permissions');
    // if(modelWisePermissions) {
    //   const modelWisePermissionsJSON = JSON.parse(modelWisePermissions);
    //   if(modelWisePermissionsJSON) {
    //       this.permissionsLoading(true); 
    //       let allMyListPermissions = [];
    //         Object.values(modelWisePermissionsJSON).forEach(el => {
    //           const filteredList = el.filter(e => true || e.includes("-list"))
            
    //         allMyListPermissions =  allMyListPermissions.concat(filteredList);
    //     })


          

    //      let  allMyListUrls = ["/employee/bulk-upload"];
    //     allMyListPermissions.forEach(el => {
         
    //       if(allPermissionsWithRoutes[el]) {
    //         allMyListUrls = allMyListUrls.concat(allPermissionsWithRoutes[el])
    //       }
    //     });

    //     this.permittedRoutes = allMyListUrls

    //     this.permissionsLoading(false)
    //     }


    // }  
    
  },
  beforeUnmount() {
    window.removeEventListener(
      "global-geofence-status-updated",
      this.handleGlobalGeofenceStatusUpdated
    );
  }
};
</script>

<style scoped>
.powered-by {
  background-color: #fff;
  border-radius: 15px;
  border: 1px solid var(--primary-color);
  color: rgba(0, 0, 0, 0.60);
  width: 100%;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
</style>
